/** Display order for known account types; unknown types sort after these, alphabetically. */
export const ACCOUNT_TYPE_ORDER = [
  "checking",
  "savings",
  "credit",
  "cash",
  "other",
  "off_budget",
] as const;

const TYPE_LABEL: Record<string, string> = {
  checking: "Checking",
  savings: "Savings (goal / emergency)",
  credit: "Credit",
  cash: "Cash",
  other: "Other",
  off_budget: "Off Budget",
};

export function accountTypeLabel(type: string): string {
  return TYPE_LABEL[type] ?? type;
}

export function compareAccountTypes(a: string, b: string): number {
  const ia = ACCOUNT_TYPE_ORDER.indexOf(a as (typeof ACCOUNT_TYPE_ORDER)[number]);
  const ib = ACCOUNT_TYPE_ORDER.indexOf(b as (typeof ACCOUNT_TYPE_ORDER)[number]);
  if (ia === -1 && ib === -1) return a.localeCompare(b);
  if (ia === -1) return 1;
  if (ib === -1) return -1;
  return ia - ib;
}
